import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../../i18n/config';
import { Card } from '../../ui/card';

/**
 * Empty chat state component
 */
const EmptyChat: React.FC = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <Card
      dir={getLanguageDirection(i18n.language)}
      className="py-12 px-8 my-4 flex flex-col items-center justify-center text-center border-2 border-dashed border-gold/20 bg-background/70 max-w-2xl mx-auto"
    >
      {/* Icon container */}
      <div className="w-20 h-20 flex items-center justify-center rounded-3xl mb-6 bg-gradient-to-br from-gold/15 to-gold/5 border border-gold/20 shadow-lg">
        <MessageSquare
          size={36}
          strokeWidth={1.5}
          className="text-gold opacity-80"
        />
      </div>
      
      {/* Main heading */}
      <h2 className="text-2xl font-semibold mb-3 text-foreground tracking-tight">
        {t('components.chats.emptyChat.title')}
      </h2>
      
      {/* Description */}
      <p className="text-base text-muted-foreground/90 mb-4 max-w-md">
        {t('components.chats.emptyChat.description')}
      </p>
      
      {/* Features list */}
      <div className="mt-2 flex flex-col gap-3 max-w-sm">
        {[
          t('components.chats.emptyChat.features.cases'),
          t('components.chats.emptyChat.features.documents'),
          t('components.chats.emptyChat.features.precedents'),
          t('components.chats.emptyChat.features.research')
        ].map((feature, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="w-6 h-6 rounded-lg flex items-center justify-center bg-gold/10 text-gold shrink-0">
              <span className="text-xs font-semibold">{index + 1}</span>
            </div>
            <p className="text-sm text-muted-foreground font-medium text-left">
              {feature}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default EmptyChat;
